import React from "react";
export default function Selector({ handleChange, value, increase, decrease }) {
  return (
    <div className="inline-block" onClick={(e) => e.stopPropagation()}>
      <div className="flex mr-xs border rounded-md">
        <SelectorInput handleChange={handleChange} value={value} />
        <div className="flex flex-col justify-center w-12 border-l">
          <SelectorButton handleClick={increase} direction={"up"} />
          <SelectorButton handleClick={decrease} direction={"down"} />
        </div>
      </div>
    </div>
  );
}

const SelectorInput = ({ handleChange, value }) => {
  if (!handleChange) {
    // Not an input, display div
    return (
      <div className="flex-grow p-2 w-20 rounded-md text-xs leading-8 text-center">
        {value}
      </div>
    );
  }
  return (
    <input
      className="flex-grow p-2 w-12 rounded-md text-xs leading-8 text-center"
      onChange={handleChange}
      value={value}
    />
  );
};

const SelectorButton = ({ handleClick, direction = "up" }) => {
  const src =
    direction === "up"
      ? "https://csb-72hdo-startingblock.vercel.app/images/svg/carrotUp.svg"
      : "https://csb-72hdo-startingblock.vercel.app/images/svg/carrotDown.svg";
  return (
    <button
      type="button"
      className="flex justify-center items-center h-full"
      onClick={handleClick}
    >
      <img src={src} alt={direction} />
    </button>
  );
};
